// extracted by mini-css-extract-plugin
export default {"icon":"Progress_icon__oznmn"};